module.exports = __webpack_public_path__ + "static/media/location.eaf58d0b.svg";